import {CreateFields, PromoCodeFormFields} from '../../types/forms'

export const usePromoCodeFields: CreateFields<PromoCodeFormFields> = ({form: {control}}) => {
  const fields = {
    code: {
      name: `code`,
      type: 'text' as const,
      defaultValue: '',
      placeholder: 'Insert Code',
      control,
    },
  }

  return fields
}
